import { useTranslation } from "react-i18next"
import { CircleAlert } from "lucide-react"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@nexus/ui"

/**
 * Explains why the Creative-grouped rows add up to less than the footer Total: spend on
 * ads with a placeholder creative ID counts in the Total but has no row (AD-2370).
 */
export function PlaceholderSpendHint({ amount }: { amount: string }) {
  const { t } = useTranslation()
  const message = t("drilldown.list.placeholderSpend", {
    amount,
    defaultValue: "Includes {{amount}} from ads with no creative ID. They aren't shown as rows.",
  })

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex size-4 shrink-0 items-center justify-center rounded-full text-muted-foreground outline-none hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring/40"
            aria-label={message}
          >
            <CircleAlert className="size-3.5" aria-hidden />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[280px] leading-relaxed">
          {message}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
